// extracted by mini-css-extract-plugin
export var label = "_hi-2";
export var slideContainer = "_hi-0";
export var slider = "_hi-1";